<script setup>
import { faqItems } from '../../config/pageData.js';
import { logEvent } from '@/utils/firebase.js';

const onToggle = (i, e) => {
  if (e.target.open) {
    logEvent('mobile_fengsuids_faq_open', { faq_index: i + 1 });
  }
};
</script>

<template>
  <section class="m-sec">
    <h2 class="m-title">報名前，你可能想問</h2>
    <div class="m-faq">
      <details
        v-for="(item, i) in faqItems"
        :key="i"
        :open="i === 0"
        @toggle="onToggle(i, $event)"
      >
        <summary>{{ item.q }}</summary>
        <div class="m-faq-a">{{ item.a }}</div>
      </details>
    </div>
  </section>
</template>

<style scoped lang="scss">
.m-sec {
  padding: 96px 32px;
}

.m-title {
  font-size: 44px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  color: #16241d;
  letter-spacing: 1px;
}

.m-faq {
  margin-top: 44px;

  details {
    background: #fff;
    border: 1px solid #e7dfcc;
    border-radius: 16px;
    margin-bottom: 18px;
  }

  summary {
    cursor: pointer;
    padding: 32px 60px 32px 44px;
    font-size: 28px;
    font-weight: 700;
    color: #16241d;
    list-style: none;
    position: relative;

    &::-webkit-details-marker {
      display: none;
    }

    &::after {
      content: '+';
      position: absolute;
      right: 44px;
      top: 50%;
      transform: translateY(-50%);
      color: #a8823f;
      font-size: 34px;
      line-height: 1;
    }
  }

  details[open] summary::after {
    content: '−';
  }

  .m-faq-a {
    padding: 0 44px 32px;
    font-size: 26px;
    color: #6f6a5c;
  }
}
</style>
